import Vue from 'vue';

Vue.component('dashboard-inventory-index', () =>
    import(/* webpackChunkName: 'dashboard-index' */ './dashboard-inventory-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/franchise-inventory/dashboard/index.js